/** Important **/
/** You should not be committing this file to GitHub **/
/** Repeat: DO! NOT! COMMIT! THIS! FILE! TO! YOUR! REPO! **/
export const sessionSecret = process.env.SESSION_SECRET || 'Your Session Secret goes here';
export const google = {
  clientID: process.env.GOOGLE_CLIENTID || '797058673908-63e0ikb87tc1mltus28amu21796iddmd.apps.googleusercontent.com',
  clientSecret: process.env.GOOGLE_SECRET || 'utlQZ-MI1VvnzLJ4uYNBV2C1',
  callbackURL: process.env.GOOGLE_CALLBACK || '/auth/google/callback'
};

export const facebook = {
  clientID: process.env.FACEBOOK_CLIENTID || '2000788673507208',
  clientSecret: process.env.FACEBOOK_SECRET || '65e506b5c9b686901074128ce169c058',
  callbackURL: process.env.FACEBOOK_CALLBACK || '/auth/facebook/callback'
}

export const shopify = {
  clientID: process.env.SHOPIFY_CLIENTID || '12df4e971c992d1c6ed3d07748b3c0a0',
  clientSecret: process.env.SHOPIFY_SECRET || '27e8a8975bc0ab77daaedb0da498e5ae',
  callbackURL: process.env.SHOPIFY_CALLBACK || "/auth/sp/callback"
}



// WEBPACK FOOTER //
// config/secrets.js